module.exports = __webpack_public_path__ + "assets/img/email-9bb7db52.png";